var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "编辑员工备注",
        visible: _vm.visible,
        center: "",
        "close-on-click-modal": false,
        width: "554px",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-alert",
        {
          staticClass: "alert",
          attrs: { title: "", type: "info", closable: false, "show-icon": "" },
        },
        [
          _vm._v(
            " 员工备注长度1-16位字符，只可以输入汉字、字母或数字，汉字算两个字符。 "
          ),
        ]
      ),
      _c(
        "el-form",
        {
          staticClass: "y-mt-20",
          attrs: { "label-width": "100px", inline: false },
        },
        [
          _c(
            "div",
            { staticClass: "view-content" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "员工备注" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "250px" },
                    attrs: { placeholder: "请输入员工备注" },
                    model: {
                      value: _vm.userNickName,
                      callback: function ($$v) {
                        _vm.userNickName = $$v
                      },
                      expression: "userNickName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { plain: "" }, on: { click: _vm.handleClose } },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleUpdate } },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }